module.exports = __webpack_public_path__ + "static/media/Antiragging.0ff95889.pdf";